module.exports = __webpack_public_path__ + "img/Asset189.ff212824.svg";